import OpenInNewRoundedIcon from "@mui/icons-material/OpenInNewRounded";
import { Box, Typography } from "@mui/material";
import useColors from "../../../../../../api/hooks/useColors";
import CustomToolTip from "../../../../../../components/CustomTooltip";
import TextIntegrationStyle from "../../TextIntegrationStyle";
import GoogleAppDetailsView from "./GoogleAppDetailsView";
import NotionAppDetailsView from "./NotionAppDetailsView";
import SalesforceAppDetailsView from "./SalesforceAppDetailsView";

const AppDetailsView = ({ entityData }) => {
  const colors = useColors();
  return (
    <Box display={"flex"} flexDirection={"column"} gap={2}>
      {(entityData?.okta_data?.status || entityData?.zoom_data?.app_status) && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant={"subtitle2"}>Status</Typography>
          </Box>
          {entityData?.okta_data?.status && (
            <Box display={"flex"} gap={2} ml={2}>
              <TextIntegrationStyle
                title={""}
                value={entityData?.okta_data?.status}
              ></TextIntegrationStyle>
            </Box>
          )}
          {entityData?.zoom_data?.app_status && (
            <Box display={"flex"} gap={2} ml={2}>
              <TextIntegrationStyle
                title={""}
                value={entityData?.zoom_data?.app_status}
              ></TextIntegrationStyle>
            </Box>
          )}
        </Box>
      )}
      {entityData?.okta_data?.sign_in_method && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant={"subtitle2"}>Sign In Method</Typography>
          </Box>
          <Box display={"flex"} gap={2} ml={2}>
            <TextIntegrationStyle
              title={""}
              value={entityData?.okta_data?.sign_in_method}
            ></TextIntegrationStyle>
          </Box>
        </Box>
      )}
      {entityData?.okta_data?.access_policy_name && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>Authentication Policy</Typography>
          </Box>
          <Box ml={2} display={"flex"} alignItems={"center"} gap={1}>
            <TextIntegrationStyle
              title={""}
              value={entityData?.okta_data?.access_policy_name}
            ></TextIntegrationStyle>
            {entityData?.okta_data?.access_policy_link && (
              <CustomToolTip title="Open link in new tab" placement="top">
                <a
                  href={entityData.okta_data?.access_policy_link}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <OpenInNewRoundedIcon
                    sx={{ width: "12px", color: colors.action_active }}
                  />
                </a>
              </CustomToolTip>
            )}
          </Box>
        </Box>
      )}
      {entityData?.okta_data?.domain && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant={"subtitle2"}>Domain</Typography>
          </Box>
          <Box display={"flex"} gap={2} ml={2}>
            <TextIntegrationStyle
              title={""}
              value={entityData?.okta_data?.domain}
            ></TextIntegrationStyle>
          </Box>
        </Box>
      )}
      {entityData?.okta_data?.allow_password_revealing !== undefined && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant={"subtitle2"}>
              Allow Password Revealing
            </Typography>
          </Box>
          <Box display={"flex"} gap={2} ml={2}>
            <TextIntegrationStyle
              title={""}
              value={
                entityData?.okta_data?.allow_password_revealing ? "Yes" : "No"
              }
            ></TextIntegrationStyle>
          </Box>
        </Box>
      )}
      {entityData?.zoom_data?.app_type && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant={"subtitle2"}>Type</Typography>
          </Box>
          <Box display={"flex"} gap={2} ml={2}>
            <TextIntegrationStyle
              title={""}
              value={entityData?.zoom_data?.app_type}
            ></TextIntegrationStyle>
          </Box>
        </Box>
      )}
      {entityData?.zoom_data?.app_developer_type && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant={"subtitle2"}>Developer Type</Typography>
          </Box>
          <Box display={"flex"} gap={2} ml={2}>
            <TextIntegrationStyle
              title={""}
              value={entityData?.zoom_data?.app_developer_type}
            ></TextIntegrationStyle>
          </Box>
        </Box>
      )}
      {entityData?.zoom_data?.app_usage && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant={"subtitle2"}>Usage Count</Typography>
          </Box>
          <Box display={"flex"} gap={2} ml={2}>
            <TextIntegrationStyle
              title={""}
              value={entityData?.zoom_data?.app_usage}
            ></TextIntegrationStyle>
          </Box>
        </Box>
      )}

      {entityData?.notion_data && (
        <NotionAppDetailsView entityData={entityData} />
      )}
      {entityData?.salesforce_data && (
        <SalesforceAppDetailsView entityData={entityData} />
      )}
      {entityData?.google_data && (
        <GoogleAppDetailsView entityData={entityData} />
      )}
    </Box>
  );
};

export default AppDetailsView;
